import React, { useEffect, useState, useRef } from 'react';
import styles from './styles';
import { getEmptyReceivingSchedule } from '@/actions';
import { useNotify, Loading } from 'react-admin';
import { Icons, TerminalsIcon } from '@/assets';
import { Icon } from '@mui/material';
import { Tooltip, Grid, Button } from '@material-ui/core';
import Select from 'react-select';
import { ReactSVG } from 'react-svg';
import DateInput from '@/components/DateInput';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import LoadingV2 from '@/components/Loading';
import timeAgo from '@/ctUtlis/timeAgo';
import DateSelector from './DateSelector';
import TooltipV2 from '@/components/Tooltip';
import ShiftStatus from './ShiftStatus';

export default ({ TerminalList, DATADefault, submitFilter }) => {
  const [openIndex, setOpenIndex] = useState(null); // Track the index of the open dropdown

  const [loading, setLoading] = React.useState(false);
  const [filteredData, setFilteredData] = useState(DATADefault);
  const [Terminals, setTerminals] = React.useState(TerminalList);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [sizeSelectOptions, setSizeSelectOptions] = useState(null);
  const [sslSelectOptions, setSslSelectOptions] = useState(null);
  const [selectedSIZE, setSelectedSize] = useState(null);
  const [selectedSSL, setSelectedSSL] = useState();
  const selectOp = useSelector((state) => state.reducer);
  const setForm = (it, val) => setFormData({ ...form, [it]: val });
  const todayDate = new Date();
  const dropdownRef = useRef(null);
  const [form, setFormData] = React.useState({
    size: null,
    ssl: null,
    date: new Date(),
    count: '',
    loc: null,
    containers: [],
  });
  console.log('yes');

  const cls = styles();
  const [selectedTab, setSelectedTab] = useState();
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = { month: mm, day: dd, year: yyyy };

  const amirbiosRef = useRef(null);
  const tableRef = useRef(null);
  const amirbios1Ref = useRef(null);
  const amirbios2Ref = useRef(null);
  const nextColRef = useRef(null);
  const terminalColRef = useRef(null);
  const shiftColRef = useRef(null);
  const shiftRef1 = useRef(null);
  const shiftRef2 = useRef(null);

  const mainScroll = document.getElementsByTagName('main')[0];
  const [tableWidth, setTableWidth] = useState(0);
  const [spanWidth, setSpanWidth] = useState(0);
  const [terminalWidth, setTerminalWidth] = useState(0);
  const [testtt, setTesttt] = useState(``);

  useEffect(() => {
    const sslSelectOptions = Object.keys(DATADefault).map((i, index) => ({
      label: i,
      value: index + 1,
    }));
    setSslSelectOptions(sslSelectOptions);
    sslSelectOptions.unshift({ label: 'All', value: 0 });
    setSelectedSSL(sslSelectOptions[0]);
    const sizeSelectOptions = Object.keys(filteredData['ANL']?.containers).map(
      (i, index) => ({ label: i, value: index + 1 })
    );
    setSizeSelectOptions(sizeSelectOptions);
    sizeSelectOptions.unshift({ label: 'All', value: 0 });
    setSelectedSize(sizeSelectOptions[0]);
  }, [DATADefault]);

  useEffect(() => {
    setSelectedTab(`${today.year}-${today.month}-${today.day}`);
  }, []);

  useEffect(() => {
    if (selectedDate && !submitFilter?.date) {
      const selectedDateFormatted = formatDate(selectedDate);
      changeTableDate(
        `${selectedDateFormatted.year}-${selectedDateFormatted.monthNumber}-${selectedDateFormatted.day}`
      );
      setSelectedTab(
        `${selectedDateFormatted.year}-${selectedDateFormatted.monthNumber}-${selectedDateFormatted.day}`
      );
    }
  }, [selectedDate, submitFilter?.date]);

  const changeTableDate = (date) => {
    handleChangeTable(date);
    setLoading(true);
    getEmptyReceivingSchedule(date)
      .then((res) => {
        setTerminals(res.data.restrictions);
        setLoading(false);
      })
      .catch((err) => {
        notify(err, 'warning');
        setLoading(false);
      });
  };

  const notify = useNotify();

  const handleChangeTable = (index) => {
    setSelectedTab(index);
  };

  function getCurrentWeekDates(daydate) {
    const today = new Date();

    // Adjust for Monday-based weeks: getDay() returns 0 for Sunday, 1 for Monday, etc.
    const currentDay = (daydate.getDay() + 6) % 7; // Adjust so Monday is 0 and Sunday is 6

    const firstDayOfWeek = new Date(daydate);
    firstDayOfWeek.setDate(daydate.getDate() - currentDay);

    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(firstDayOfWeek);
      date.setDate(firstDayOfWeek.getDate() + i);
      dates.push(date);
    }
    return dates;
  }

  // Example usage:
  const someDate = new Date(); // You can replace this with any date you want
  getCurrentWeekDates(someDate);

  const Reset = () => {
    setSelectedDate(todayDate);
    setSelectedSize(sizeSelectOptions[0]);
    setSelectedSSL(sslSelectOptions[0]);
    setFormData({
      size: sizeSelectOptions[0],
      ssl: sslSelectOptions[0],
      date: new Date(),
    });
  };

  // Format the date to separate day, abbreviated month, and year
  function formatDate(date, format) {
    const day = date.getDate().toString().padStart(2, '0');
    const dayNumber = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const dayName = dayNames[date.getDay()];
    const monthNumber = String(monthIndex + 1).padStart(2, '0'); // Add leading zero if necessary
    const month = monthNames[monthIndex];
    if (format == 1) {
      return `${year}-${monthNumber}-${day}`;
    } else {
      return { day, dayNumber, dayName, monthNumber, month, year };
    }
  }
  // Print the dates of the current week
  const weekDates = getCurrentWeekDates(selectedDate);
  const formattedDates = weekDates.map((date) => formatDate(date));
  // const originalDate = "2024-04-20T04:31:52.000000Z";

  useEffect(() => {
    const handleScroll = () => {
      if (amirbiosRef.current && amirbios1Ref.current) {
        const amirbiosTop = amirbiosRef.current.getBoundingClientRect().top;
        if (amirbiosTop <= 12) {
          if (amirbios2Ref.current) {
            amirbios2Ref.current.classList.add(cls.fix);
            amirbios2Ref.current.classList.add(cls.showShift);
          }
          if (shiftRef1.current) {
            shiftRef1.current.classList.add(cls.hideShift);
          }
          if (shiftRef2.current) {
            shiftRef2.current.classList.add(cls.hideShift);
          }
          if (tableRef.current) {
            tableRef.current.classList.add(cls.tableTopMargin);
          }
        } else {
          if (amirbios2Ref.current) {
            amirbios2Ref.current.classList.remove(cls.fix);
            amirbios2Ref.current.classList.remove(cls.showShift);
          }
          if (shiftRef1.current) {
            shiftRef1.current.classList.remove(cls.hideShift);
          }
          if (shiftRef2.current) {
            shiftRef2.current.classList.remove(cls.hideShift);
          }
          if (tableRef.current) {
            tableRef.current.classList.remove(cls.tableTopMargin);
          }
        }
      }
      syncScroll('amirbios');
      setOpenIndex(false);
    };
    const updateWidth = () => {
      if (tableRef.current && amirbios1Ref.current) {
        const tableCurrentWidth =
          tableRef.current.getBoundingClientRect().width;
        setTableWidth(tableCurrentWidth);
      }
    };

    const updateHeadWidth = () => {
      if (amirbiosRef.current && amirbios2Ref.current) {
        const tableeCurrentWidth =
          amirbiosRef.current.getBoundingClientRect().width;
        setSpanWidth(tableeCurrentWidth);
      }
    };

    const updateTerminalWidth = () => {
      if (nextColRef.current) {
        const terminalCurrentWidth =
          nextColRef.current.getBoundingClientRect().width;
        setTerminalWidth(terminalCurrentWidth);
      }
    };

    const syncScroll = (source) => {
      if (amirbiosRef.current && amirbios2Ref.current) {
        if (source === 'amirbios') {
          amirbios2Ref.current.scrollLeft = amirbiosRef.current.scrollLeft;
        } else if (source === 'amirbios2') {
          amirbiosRef.current.scrollLeft = amirbios2Ref.current.scrollLeft;
        }
      }
    };

    // Initial width setting
    updateWidth();
    updateHeadWidth();
    updateTerminalWidth();

    window.updateWidth = updateWidth;
    window.updateHeadWidth = updateHeadWidth;
    window.syncScroll = syncScroll;

    mainScroll.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', updateWidth);
    window.addEventListener('resize', updateHeadWidth);
    window.addEventListener('resize', updateTerminalWidth);
    mainScroll.addEventListener('scroll', updateTerminalWidth);
    if (amirbiosRef.current) {
      amirbiosRef.current.addEventListener('scroll', () => {
        syncScroll('amirbios');
      });
    }
    if (amirbios2Ref.current) {
      amirbios2Ref.current.addEventListener('scroll', () => {
        syncScroll('amirbios2');
      });
    }

    // Cleanup on component unmount
    return () => {
      mainScroll.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateWidth);
      window.removeEventListener('resize', updateHeadWidth);
      window.removeEventListener('resize', updateTerminalWidth);
      mainScroll.removeEventListener('scroll', updateTerminalWidth);
      if (amirbiosRef.current) {
        amirbiosRef.current.removeEventListener('scroll', () =>
          syncScroll('amirbios')
        );
      }
      if (amirbios2Ref.current) {
        amirbios2Ref.current.removeEventListener('scroll', () =>
          syncScroll('amirbios2')
        );
      }
    };
  }, []);

  if (amirbios2Ref.current) {
    amirbios2Ref.current.style.width = `${spanWidth - 1}px`;
  }

  if (amirbios1Ref.current) {
    amirbios1Ref.current.style.width = `${tableWidth}px`;
  }

  if (terminalColRef.current) {
    terminalColRef.current.style.minWidth = `${
      terminalWidth - 0.01 * terminalWidth - 2
    }px`;
  }
  if (shiftColRef.current) {
    shiftColRef.current.style.minWidth = `${
      terminalWidth - 0.01 * terminalWidth - 2
    }px`;
  }

  // Function to filter data based on selected SSL
  const filterDataBySSL = (data, submitFilter) => {
    const { ssl, size, date } = submitFilter;

    const filteredBySSL =
      !ssl || ssl.label === 'All'
        ? data
        : Object.keys(data).reduce((acc, key) => {
            if (key === ssl.label) {
              acc[key] = data[key];
            }
            return acc;
          }, {});

    // Then filter by Size within the filtered SSL data
    const filteredBySize =
      !size || size.label === 'All'
        ? filteredBySSL
        : Object.keys(filteredBySSL).reduce((acc, key) => {
            acc[key] = {
              ...filteredBySSL[key],
              containers: Object.keys(filteredBySSL[key].containers)
                .filter((containerKey) => containerKey === size.label)
                .reduce((obj, containerKey) => {
                  obj[containerKey] =
                    filteredBySSL[key].containers[containerKey];
                  return obj;
                }, {}),
            };
            return acc;
          }, {});

    return filteredBySize;
  };

  useEffect(() => {
    setLoading(true);
    const filteredDataa = filterDataBySSL(DATADefault, submitFilter);
    setFilteredData(filteredDataa);

    // Update selectedDate and selectedTab when date filter is applied
    if (submitFilter?.date) {
      setSelectedDate(submitFilter.date);
      const selectedDateFormatted = formatDate(submitFilter.date);
      const newDateKey = `${selectedDateFormatted.year}-${selectedDateFormatted.monthNumber}-${selectedDateFormatted.day}`;
      setSelectedTab(newDateKey);

      // Load data for the new date
      handleChangeTable(newDateKey);
      getEmptyReceivingSchedule(newDateKey)
        .then((res) => {
          setTerminals(res.data.restrictions);
          setLoading(false);
        })
        .catch((err) => {
          notify(err, 'warning');
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [DATADefault, submitFilter]);

  return (
    <>
      <div
        ref={amirbiosRef}
        id="amirbios"
        className={`${cls.listContainerUser} mt-4`}>
        {/* Date Selector Component */}
        <div className="my-4 flex justify-between w-full lt1450:w-max  gap-4">
          <DateSelector
            dates={formattedDates.map((date) => ({
              key: `${date.year}-${date.monthNumber}-${date.day}`,
              dayName: date.dayName,
              dayNumber: date.dayNumber,
              month: date.month,
            }))}
            selectedDate={selectedTab}
            onDateSelect={(dateKey) => changeTableDate(dateKey)}
            className=""
          />
          <div id="legendSection" className="flex gap-4 text-sm">
            <span className="flex flex-row items-center text-11">
              <ReactSVG src={Icons.tickICon} className="w-5 h-4.1" />
              Open for receiving
            </span>
            <span className="flex flex-row items-center text-11">
              <ReactSVG className="w-5 h-4.1 pb-0.5" src={Icons.close} />
              Closed for receiving
            </span>
            <span className="flex flex-row items-center -mt-0.5 text-11">
              <ReactSVG className="w-5 h-4.1 pt-0.5" src={Icons.transaction} />
              Dual transactions only
            </span>
            <span className="flex flex-row items-center -mt-1 text-11">
              <ReactSVG className="w-5 h-4.1 pt-0.5" src={Icons.message} />
              Hover for messages
            </span>
          </div>
        </div>
        <table ref={tableRef} id="table" className="border-collapse">
          <thead
            className={cls.list}
            ref={amirbios2Ref}
            id="amirbios1"
            style={{ display: 'none' }}>
            <tr className={cls.tableRow} ref={amirbios1Ref} id="amirbios2">
              <th ref={terminalColRef} scope="col" className="text-xs">
                Terminal
              </th>
              {Object.keys(Terminals).map((idx) => (
                <td
                  scope="col"
                  className=" min-w-24 w-[6%] p-0 text-xs py-1"
                  style={{ border: '1px solid #E1E4EA', minWidth: '104.13px' }}>
                  <a
                    className="flex flex-col font-bold"
                    style={{ color: '#43424b' }}
                    target="_blank"
                    href={Terminals[idx].links?.restriction}>
                    <img
                      className="border-b"
                      width={'100%'}
                      src={
                        idx == 'APM'
                          ? TerminalsIcon.APM
                          : idx == 'FMS'
                          ? TerminalsIcon.FMS
                          : idx == 'EVERPORT'
                          ? TerminalsIcon.EVERPORT
                          : idx == 'LACT'
                          ? TerminalsIcon.LACT
                          : idx == 'PCT'
                          ? TerminalsIcon.PCT
                          : idx == 'PST'
                          ? TerminalsIcon.PST
                          : idx == 'TRAPAC'
                          ? TerminalsIcon.TRAPAC
                          : idx == 'WBCT'
                          ? TerminalsIcon.WBCT
                          : idx == 'WCC'
                          ? TerminalsIcon.WCC
                          : idx == 'YTI'
                          ? TerminalsIcon.YTI
                          : idx == 'TTI'
                          ? TerminalsIcon.TTI
                          : idx == 'ITS'
                          ? TerminalsIcon.ITS
                          : idx == 'LBCT'
                          ? TerminalsIcon.LBCT
                          : idx == 'MATSON'
                          ? TerminalsIcon.MATSON
                          : idx == 'SSA MARINE'
                          ? TerminalsIcon.SSA
                          : idx == 'SSA STL'
                          ? TerminalsIcon.STL
                          : idx == 'PTS'
                          ? TerminalsIcon.PTS
                          : ''
                      }
                    />
                    <span className="min-h-[55px] h-max flex flex-col justify-center">
                      <span className="h-4 text-11">{idx}</span>
                    </span>
                  </a>
                  <span className="min-h-[55px] h-max flex flex-col justify-center">
                    <span className="h-4 text-11">
                      {Terminals[idx].pier ? Terminals[idx].pier : ' '}
                    </span>
                    <span className="h-4">
                      {Terminals[idx].blur_status === 1
                        ? 'No Data'
                        : Terminals[idx].restrictions_latest3?.updated_at
                        ? timeAgo(
                            Terminals[idx].restrictions_latest3?.updated_at
                          )
                        : ''}
                    </span>
                  </span>
                </td>
              ))}
            </tr>
            <tr className={cls.tableRow}>
              <th ref={shiftColRef} scope="col" className="text-xs">
                Shift Status
              </th>
              {Object.keys(Terminals).map((idx) => (
                <td
                  className="min-w-20 w-[6%] p-0 text-xs"
                  style={{ border: '1px solid #E1E4EA' }}>
                  <span className="flex items-center justify-evenly h-[42px] min-w-20 -mb-0">
                    <span
                      className="w-full flex justify-center h-12 w-fill-available items-center font-bold"
                      colSpan="1">
                      1st
                    </span>
                    <span
                      className="w-full flex justify-center h-12 w-fill-available items-center font-bold"
                      colSpan="1">
                      2nd
                    </span>
                  </span>
                </td>
              ))}
            </tr>
          </thead>
        </table>
        {loading ? (
          <div className="mt-16">
            <LoadingV2 />
          </div>
        ) : (
          <>
            <table className={`${cls.list} border-collapse`}>
              <thead
                // ref={amirbios2Ref}
                // id="amirbios2"
                className={cls.theadSticky}>
                {testtt ? (
                  <span dangerouslySetInnerHTML={{ __html: testtt }} />
                ) : (
                  <span></span>
                )}
                <tr
                  style={{ flex: 0.2 }}
                  ref={shiftRef1}
                  id=""
                  className={cls.tableHeaderRow}>
                  <th
                    // ref={terminalColRef}
                    scope="col"
                    className="text-xs">
                    Terminal
                  </th>
                  {Object.keys(Terminals).map((idx) => (
                    <td
                      scope="col"
                      className="min-w-20 w-[6%] p-0 text-xs py-1"
                      style={{ border: '1px solid #E1E4EA' }}>
                      <a
                        className="flex flex-col font-bold"
                        style={{ color: '#43424b' }}
                        target="_blank"
                        href={Terminals[idx].links?.restriction}>
                        <img
                          className="border-b"
                          width={'100%'}
                          src={
                            idx == 'APM'
                              ? TerminalsIcon.APM
                              : idx == 'FMS'
                              ? TerminalsIcon.FMS
                              : idx == 'EVERPORT'
                              ? TerminalsIcon.EVERPORT
                              : idx == 'LACT'
                              ? TerminalsIcon.LACT
                              : idx == 'PCT'
                              ? TerminalsIcon.PCT
                              : idx == 'PST'
                              ? TerminalsIcon.PST
                              : idx == 'TRAPAC'
                              ? TerminalsIcon.TRAPAC
                              : idx == 'WBCT'
                              ? TerminalsIcon.WBCT
                              : idx == 'WCC'
                              ? TerminalsIcon.WCC
                              : idx == 'YTI'
                              ? TerminalsIcon.YTI
                              : idx == 'TTI'
                              ? TerminalsIcon.TTI
                              : idx == 'ITS'
                              ? TerminalsIcon.ITS
                              : idx == 'LBCT'
                              ? TerminalsIcon.LBCT
                              : idx == 'MATSON'
                              ? TerminalsIcon.MATSON
                              : idx == 'SSA MARINE'
                              ? TerminalsIcon.SSA
                              : idx == 'SSA STL'
                              ? TerminalsIcon.STL
                              : idx == 'PTS'
                              ? TerminalsIcon.PTS
                              : ''
                          }
                        />
                        <span className="min-h-[55px] h-max flex flex-col justify-center">
                          <span className="h-4 text-11 font-averta-bold">
                            {idx}
                          </span>
                        </span>
                      </a>
                      <span className="min-h-[55px] h-max flex flex-col justify-center">
                        <span className="h-4 text-11">
                          {Terminals[idx].pier ? Terminals[idx].pier : ' '}
                        </span>
                        <span className="h-4">
                          {Terminals[idx].blur_status === 1
                            ? 'No Data'
                            : Terminals[idx].restrictions_latest3?.updated_at
                            ? timeAgo(
                                Terminals[idx].restrictions_latest3?.updated_at
                              )
                            : ''}
                        </span>
                      </span>
                    </td>
                  ))}
                </tr>
                <tr style={{ flex: 0.2 }} className={cls.tableHeaderRow}>
                  <th className="text-xs">Gate Status</th>
                  {Object.keys(Terminals).map((idx) => (
                    <td
                      className={`${cls.tableTdUser}
                      `}>
                      <span
                        className={`px-2 py-0.5 rounded-full text-9 mx-1 ${
                          Terminals[idx].gate_status_shift1 === 1
                            ? 'text-success bg-success-light'
                            : Terminals[idx].gate_status_shift1 === 0
                            ? 'text-error-10 bg-error-light'
                            : 'text-black px-5'
                        }`}>
                        {Terminals[idx].gate_status_shift1 == 1
                          ? 'Open'
                          : Terminals[idx].gate_status_shift1 == 0
                          ? 'Closed'
                          : Terminals[idx].gate_status_shift1 == 2
                          ? 'Dual'
                          : ''}
                      </span>
                      <span
                        className={`px-2 py-0.5 rounded-full text-9 mx-1 ${
                          Terminals[idx].gate_status_shift2 === 1
                            ? 'text-success bg-success-light'
                            : Terminals[idx].gate_status_shift2 === 0
                            ? 'text-error-10 bg-error-light'
                            : 'text-black px-5'
                        }`}>
                        {Terminals[idx].gate_status_shift2 == 1
                          ? 'Open'
                          : Terminals[idx].gate_status_shift2 == 0
                          ? 'Closed'
                          : Terminals[idx].gate_status_shift2 == 2
                          ? 'Dual'
                          : ''}
                      </span>
                    </td>
                  ))}
                </tr>
                <tr style={{ flex: 0.2 }} className={cls.tableHeaderRow}>
                  <th ref={nextColRef} className="text-xs">
                    Next Appointment
                  </th>
                  {Object.keys(Terminals).map((idx) => (
                    <td className={cls.tableTdUser}></td>
                  ))}
                </tr>
                <tr
                  style={{ flex: 0.2 }}
                  ref={shiftRef2}
                  className={cls.tableHeaderRow}>
                  <th className="text-xs">Shift Status</th>
                  {Object.keys(Terminals).map((idx) => (
                    <td
                      className="min-w-20 w-[6%] p-0 text-xs"
                      style={{ border: '1px solid #E1E4EA' }}>
                      <span className="flex items-center justify-evenly h-[42px] min-w-20 -mb-0">
                        <span
                          className="w-full flex justify-center h-12 w-fill-available items-center font-bold"
                          colSpan="1">
                          1st
                        </span>
                        <span
                          className="w-full flex justify-center h-12 w-fill-available items-center font-bold"
                          colSpan="1">
                          2nd
                        </span>
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody className={cls.tbody}>
                {Object.keys(filteredData)?.map((key) =>
                  key === null || key === undefined ? (
                    ''
                  ) : (
                    <>
                      {/* SSL Header Row */}
                      <tr className={cls.tableRow}>
                        <th
                          className={cls.tableTdsslname}
                          colSpan={2 + Object.keys(Terminals).length * 2}>
                          {filteredData[key].name}
                        </th>
                      </tr>
                      {/* Container Types Rows */}
                      {Object.keys(filteredData[key]?.containers).map(
                        (containerType) => (
                          <tr className={cls.tableRow}>
                            <th className={cls.sslNamesThUser}>
                              {containerType}
                            </th>
                            {Object.keys(Terminals).map((idx) => (
                              <td
                                style={{ flex: 0.2 }}
                                className={
                                  Terminals[idx].blur_status === 1
                                    ? cls.tableTdNull
                                    : cls.tableTdUser
                                }>
                                {selectedSIZE == null ||
                                selectedSIZE.label === 'All' ||
                                selectedSIZE.label === containerType ? (
                                  Terminals[idx].blur_status === 1 ? (
                                    <tr className={cls.shiftStatusUser}> </tr>
                                  ) : !Terminals[idx].restriction.parsed[
                                      key
                                    ] ? (
                                    <tr className={cls.shiftStatusUser}>
                                      <span></span>
                                    </tr>
                                  ) : (
                                    <tr className={cls.shiftStatusUser}>
                                      <span
                                        className={`${
                                          Terminals[idx].restriction.parsed[key]
                                            .containers[containerType]
                                            .shift1 === true ||
                                          Terminals[idx].restriction.parsed[key]
                                            .containers[containerType]
                                            .shift1 === 1
                                            ? cls.openUser
                                            : Terminals[idx].restriction.parsed[
                                                key
                                              ].containers[containerType]
                                                .shift1 == false ||
                                              Terminals[idx].restriction.parsed[
                                                key
                                              ].containers[containerType]
                                                .shift1 === 0
                                            ? cls.closeUser
                                            : Terminals[idx].restriction.parsed[
                                                key
                                              ].containers[containerType]
                                                .shift1 === 'DUAL' ||
                                              Terminals[idx].restriction.parsed[
                                                key
                                              ].containers[containerType]
                                                .shift1 === 2
                                            ? cls.dualUser
                                            : cls.nullStatussUser
                                        } w-48 `}>
                                        <ShiftStatus
                                          shiftData={
                                            Terminals[idx].restriction.parsed[
                                              key
                                            ].containers[containerType]
                                          }
                                          shiftType="shift1"
                                          terminalId={Terminals[idx].id}
                                          terminalSlug={Terminals[idx].slug}
                                          restrictionName={
                                            Terminals[idx].restriction?.parsed[
                                              key
                                            ].name
                                          }
                                          containerType={containerType}
                                          cls={cls}
                                          idx={idx}
                                          restrictionKey={key}
                                          selectedSIZE={selectedSIZE}
                                          selectedSSL={selectedSSL}
                                        />
                                      </span>
                                      <span
                                        className={`${
                                          Terminals[idx].restriction.parsed[key]
                                            .containers[containerType]
                                            .shift2 === true ||
                                          Terminals[idx].restriction.parsed[key]
                                            .containers[containerType]
                                            .shift2 === 1
                                            ? cls.openUser
                                            : Terminals[idx].restriction.parsed[
                                                key
                                              ].containers[containerType]
                                                .shift2 == false ||
                                              Terminals[idx].restriction.parsed[
                                                key
                                              ].containers[containerType]
                                                .shift2 === 0
                                            ? cls.closeUser
                                            : Terminals[idx].restriction.parsed[
                                                key
                                              ].containers[containerType]
                                                .shift2 === 'DUAL' ||
                                              Terminals[idx].restriction.parsed[
                                                key
                                              ].containers[containerType]
                                                .shift2 === 2
                                            ? cls.dualUser
                                            : cls.nullStatussUser
                                        } w-48 `}>
                                        <ShiftStatus
                                          shiftData={
                                            Terminals[idx].restriction.parsed[
                                              key
                                            ].containers[containerType]
                                          }
                                          shiftType="shift2"
                                          terminalId={Terminals[idx].id}
                                          terminalSlug={Terminals[idx].slug}
                                          restrictionName={
                                            Terminals[idx].restriction?.parsed[
                                              key
                                            ].name
                                          }
                                          containerType={containerType}
                                          cls={cls}
                                          idx={idx}
                                          restrictionKey={key}
                                          selectedSIZE={selectedSIZE}
                                          selectedSSL={selectedSSL}
                                        />
                                      </span>
                                    </tr>
                                  )
                                ) : null}
                              </td>
                            ))}
                          </tr>
                        )
                      )}
                    </>
                  )
                )}
              </tbody>
            </table>
          </>
        )}
      </div>
    </>
  );
};
